"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isSuccessfulStatusCode = exports.getUniqueId = exports.getEndpointData = exports.getEndpointStatusMessage = exports.getEndpointStatusCode = exports.getEndpointStatusCodeForMethod = void 0;
const hub_utilities_is_1 = require("@yw/hub.utilities.is");
const types_1 = require("../../types");
const ResponseConfig_1 = require("../ResponseConfig");
function getEndpointStatusCodeForMethod(httpMethod, code) {
    if (!isSuccessfulStatusCode(code))
        return code;
    const lowercasedHttpMethod = httpMethod === null || httpMethod === void 0 ? void 0 : httpMethod.toLowerCase();
    if (lowercasedHttpMethod === 'get')
        return code;
    switch (lowercasedHttpMethod) {
        case 'post':
            return types_1.EndpointStatusCodes.Created;
        case 'delete':
        case 'put':
        case 'patch':
            return types_1.EndpointStatusCodes.NoContent;
        default:
            return code;
    }
}
exports.getEndpointStatusCodeForMethod = getEndpointStatusCodeForMethod;
function getEndpointStatusCode(comment, status, to = ResponseConfig_1.httpCodeToEndpointStatusCode) {
    var _a;
    const code = ((_a = String(comment).match(/-?\d+/g)) === null || _a === void 0 ? void 0 : _a[0]) || String(status) || 200;
    const standardCode = to[code];
    if (!standardCode) {
        console.warn(`No standard code found for comment code ${code}`);
        return types_1.EndpointStatusCodes.Ok;
    }
    return standardCode;
}
exports.getEndpointStatusCode = getEndpointStatusCode;
function getEndpointStatusMessage(messageOrCode, code) {
    if (types_1.EndpointStatusCodeMessages.has(messageOrCode)) {
        return types_1.EndpointStatusCodeMessages.get(messageOrCode);
    }
    return messageOrCode || types_1.EndpointStatusCodeMessages.get(code);
}
exports.getEndpointStatusMessage = getEndpointStatusMessage;
function getEndpointData(data, page) {
    // Reflect.has(response.data, "data") ? response.data.data : response.data
    const whiteList = [
        'pageNo',
        'pageSize',
        'totalCount',
        'totalPage',
        'page',
        'total',
        'page_size',
        'current_page',
    ];
    if ((0, hub_utilities_is_1.isObject)(data)) {
        if (Object.keys(data).some((key) => whiteList.includes(key))) {
            if (page) {
                const resp = Object.prototype.hasOwnProperty.call(data, 'data')
                    ? data.data
                    : data;
                return Object.prototype.hasOwnProperty.call(resp, 'list')
                    ? resp.list
                    : resp;
            }
            return data;
        }
        return Object.prototype.hasOwnProperty.call(data, 'data')
            ? data.data
            : data;
    }
    return data;
}
exports.getEndpointData = getEndpointData;
function getUniqueId(uniqueId) {
    if (uniqueId === 'Ignored_Trace') {
        return Date.now();
    }
    return uniqueId || Date.now();
}
exports.getUniqueId = getUniqueId;
function isSuccessfulStatusCode(code) {
    return [
        types_1.EndpointStatusCodes.Ok,
        types_1.EndpointStatusCodes.Created,
        types_1.EndpointStatusCodes.NoContent,
    ].includes(code);
}
exports.isSuccessfulStatusCode = isSuccessfulStatusCode;
//# sourceMappingURL=index.js.map